<template>
  <OnClickOutside :do="hide">
    <div
      class="dropdown"
      :class="{ 'dropdown--active': showMenu }"
      @click="showMenu = !showMenu"
    >
      <div class="dropdown__value">
        <p class="dropdown__text">
          {{ nameFn(modelValue) }}
        </p>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 8.69995L10 14.2L15 8.69995"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <ul class="dropdown__menu">
        <li
          class="dropdown__item"
          v-for="option in optionsInternal"
          :key="idFn(option)"
          @click.stop="select(option)"
          :title="nameFn(option)"
        >
          {{ nameFn(option) }}
        </li>
      </ul>
    </div>
  </OnClickOutside>
</template>

<script>
import { ref, watch, computed } from "vue";
import OnClickOutside from "@/components/renderless/OnClickOutside";
export default {
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: null,
    },
    idFn: {
      type: Function,
    },
    nameFn: {
      type: Function,
    },
  },
  emits: ["selected", "update:modelValue"],
  components: { OnClickOutside },
  setup(props, { emit }) {
    const optionsInternal = computed(() => {
      return props.defaultValue
        ? [props.defaultValue, ...props.options]
        : [...props.options];
    });
    const showMenu = ref(false);
    const hide = () => (showMenu.value = false);
    const select = (value) => {
      hide();
      emit("selected", value);
      emit("update:modelValue", value);
    };

    watch(
      () => props.options,
      () => {
        if (optionsInternal.value.length)
          select(optionsInternal.value[0]);
        else
          select(null);
      });

    if (!props.idFn(props.modelValue) && props.defaultValue)
      select(props.defaultValue);
    else if (!props.defaultValue && optionsInternal.value.length)
      select(optionsInternal.value[0]);

    return {
      optionsInternal,
      showMenu,
      select,
      hide,
    };
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
  height: 48px;
  border-radius: 6px;
  border: 1px solid var(--basic-grey);
  width: 100%;
  min-width: 100px;
  max-width: 100%;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 13px;
  font-family: var(--font-family);
  font-size: 16px;
  color: var(--basic-black);
  white-space: nowrap;
  cursor: pointer;
}

.dropdown__value {
  display: grid;
  grid-template-columns: 1fr 20px;
}

.dropdown__text {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown:hover,
.dropdown:focus {
  border-color: var(--secondary-blue-darker);
}

.dropdown:active {
  border-color: var(--primary-blue-lighter);
}

.dropdown:hover path {
  stroke: var(--secondary-blue-darker);
}

.dropdown__menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 20;
  display: none;
  width: 100%;
  min-width: 200px;
  max-height: 470px;
  padding: 6px 0px;
  margin-top: 0;
  overflow-y: auto;
  border: 1px solid var(--basic-grey);
  border-radius: 6px;
  background-color: var(--basic-white);
  filter: var(--dropdown-shadow);
}

.dropdown--active .dropdown__menu {
  display: block;
}

.dropdown__item {
  display: block;
  padding: 6px 12px;
  color: var(--basic-black);
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  word-wrap: normal;
  white-space: -moz-pre-wrap;
  white-space: pre-wrap;
}

.dropdown__item:hover {
  background-color: var(--secondary-blue-lighter);
}

a.dropdown__item {
  text-align: inherit;
  white-space: nowrap;
  width: 100%;
}
</style>
